/* eslint-disable */
import { DictionariesService, DictionaryItem, Dictionary } from "@sa/rep-mdm";
import { orderBy } from "lodash";
import { useState, useEffect } from "react";
import { equal } from "../../../../shared";

export function useDictionary(
  dictionaryService: DictionariesService,
  id: string | undefined,
  itemIds?: unknown[],
  parameters?: any
): [DictionaryItem[] | null, Dictionary | null, boolean] {
  const [loadingDictionary, setLoadingDictionary] = useState<boolean>(false);
  const [loadingItems, setLoadingItems] = useState<boolean>(false);
  const [dict, setDict] = useState<Dictionary | null>(null);
  const [params, setParams] = useState<any | null>(null);
  const [items, setItems] = useState<DictionaryItem[] | null>(null);
  useEffect(() => {
    if (id) {
      setLoadingDictionary(true);
      (async () => {
        if (!dict || dict.id !== id || !equal(params, parameters) ) {
          const dictionary = await dictionaryService.getDictionary({
            id,
            parameters: parameters || {},
          });
          setDict(dictionary);
          setParams(parameters);
          setLoadingDictionary(false);
        }

      })();
    }
  }, [id, JSON.stringify(parameters)]);

  useEffect(() => {
    if (id) {
      setLoadingItems(true);
      (async () => {
        if (dict && !loadingDictionary) {
          let dictionaryItems: DictionaryItem[];
          if (!itemIds?.length) {
            dictionaryItems = await dict.getAll();
          } else {
            dictionaryItems = await dict.getByIds(itemIds.map(String));
          }
          const orderAttribute = (dict.definition['systemAttributes'] as any | undefined)?.Order;
          const orderKey = orderAttribute?.fieldPath?.fieldId;
          if (orderKey) {
            dictionaryItems = orderBy(dictionaryItems, item => item.values[orderKey]);
          }
          setItems(dictionaryItems);
          setLoadingItems(false);
        }
      })();
    }
  }, [dict, loadingDictionary]);
  return [items, dict, loadingDictionary || loadingItems];
}
